import * as React from "react";

import { UitkIcon } from "uitk-react-icons";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutGrid, UitkLayoutGridColumnRow } from "uitk-react-layout-grid";

import Link from "./components/Link";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { LinkJuiceCategorySectionProps } from "./typings";

const LinkJuiceCategorySection = (props: LinkJuiceCategorySectionProps) => {
  const { category, collapsed, displayColumns } = props;
  const { name, links } = category;
  if (!(name && links && links.length)) {
    return null;
  }

  const DEFAULT_MOBILE_DISPLAY_COLUMNS = 1;
  const columns = {
    small: DEFAULT_MOBILE_DISPLAY_COLUMNS as UitkLayoutGridColumnRow,
    large: Number(displayColumns) as UitkLayoutGridColumnRow,
  };

  const [isExpanded, setIsExpanded] = React.useState(!collapsed);

  const toggleExpansion = (): void => {
    setIsExpanded(!isExpanded);
  };

  const keyHelper = new ItemKeyHelper("LinkJuiceLinks");

  return (
    <UitkCard className="all-t-margin-one">
      <div
        data-testid="linkJuiceCategorySection"
        role="button"
        aria-expanded={isExpanded}
        className="header"
        onClick={toggleExpansion}
        tabIndex={0}
      >
        <UitkCardContentSection
          className="all-y-padding-four uitk-flex uitk-flex-justify-content-space-between"
          border="bottom"
        >
          <h3 className="uitk-type-heading-500">{name}</h3>
          <UitkIcon name={`expand_${isExpanded ? "less" : "more"}`} />
        </UitkCardContentSection>
      </div>

      <UitkCardContentSection
        aria-hidden={!isExpanded}
        className={`all-y-padding-two${isExpanded ? "" : " collapsedLink"}`}
      >
        <UitkLayoutGrid columns={columns} space="one">
          {links.map((link) => (
            <Link key={keyHelper.next()} link={link} />
          ))}
        </UitkLayoutGrid>
      </UitkCardContentSection>
    </UitkCard>
  );
};

export default LinkJuiceCategorySection;
